<template>
	<div class="trigger">
		<div class="button" :class="{'bordered': activeFilters}" v-html="toggleLabel"></div>

		<div class="popup">
			<div class="content">
				<slot></slot>
			</div>
			<div class="actions">
				<a class="confirm" v-html="labels.apply"></a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//
			}
		},

		props: {
			toggleLabel: {
				type: String,
				default: ''
			},

			activeFilters: {
				type: Boolean,
				default: false
			}
		},
	}
</script>
